<template>
  <div>
    <div class="has-background-white">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <form
        v-else-if="!loading && company"
        @submit.prevent.stop="submit()">
        <div class="is-padding">
          <div class="columns">
            <div class="column">
              <v-input
                id="name"
                :name="'name'"
                @input="val => company.name = val"
                :model="company.name"
                :errors-bag="errors"
                v-validate="'required|min:2'"
                data-vv-value-path="val"
                data-vv-as="Nom">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Nom société'"
                  :value="company.name"></r-label>
              </v-input>
            </div>
            <div class="column">
              <v-input
                id="siret"
                :name="'siret'"
                @input="val => company.siret = val"
                :model="company.siret"
                :errors-bag="errors"
                v-validate="'min:2'"
                data-vv-value-path="val"
                data-vv-as="Siret">
                <r-label
                  slot="label"
                  :is-required="false"
                  :label="'Siret'"
                  :value="company.siret"></r-label>
              </v-input>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <v-input
                :name="'email'"
                id="email"
                :classes-input="'is-fullwidth'"
                @input="val => company.email = val"
                :model="company.email"
                :errors-bag="errors"
                v-validate="'required|min:3|max:255|email'"
                data-vv-value-path="val"
                data-vv-as="Adresse mail"
                :has-addons="true">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Adresse mail'"
                  :value="company.email"></r-label>
                <p
                  class="control"
                  slot="addonLeft">
                  <a class="button is-square is-static is-border">
                    <span class="icon"><i class="fas fa-paper-plane"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
            <div class="column">
              <v-input
                id="phone"
                name="phone"
                @input="company.phone = $event"
                :model="company.phone"
                :errors-bag="errors"
                :input-type="'tel'"
                :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                v-validate="'required|min:10'"
                data-vv-value-path="val"
                data-vv-as="Téléphone"
                :has-addons="true">
                <r-label
                  slot="label"
                  :is-required="true"
                  :label="'Téléphone (fixe ou mobile)'"
                  :value="company.phone"
                  :truncate="false">
                  <span
                    class="is-padding-left-xsmall"
                    v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                    <i class="fal fa-info-circle"></i>
                  </span>
                </r-label>
                <p
                  class="control"
                  slot="addonLeft">
                  <a class="button is-square is-static is-border">
                    <span class="icon"><i class="fas fa-phone-office"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <address-input
                :source="company.address"
                :is-required="true"
                @update="updateAddress">
              </address-input>
            </div>
          </div>
          <div class="field">
            <r-label
              :label="'Logo société'"
              :for-id="''"
              :is-required="false">
            </r-label>
            <upload-file
              :custom-id="'avatar'"
              @upload="uploadPictures"
              @deleteDocument="deleteCompanyPicture"
              :source-documents="companyPictures"
              :unique="true"
              :is-square-input="false"></upload-file>
          </div>
        </div>
        <submit-sticky-buttons
          @submit="submit"
          :loading="submitLoading"
          button-id="accessForm"></submit-sticky-buttons>
      </form>
    </div>
  </div>
</template>

<script>
import { Error } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'MyCompany',
  mixins: [Error],
  data () {
    return {
      loading: false,
      company: null,
      companyPictures: [],
      submitLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    companyPk () {
      return this.currentUser.account.pk
    }
  },
  created () {
    this.getCompany()
  },
  methods: {
    updateAddress (address) {
      this.$set(this.company, 'address', address)
    },
    async getCompany () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT, this.companyPk)
        this.company = data
        if (this.company.picture) {
          this.companyPictures = [this.company.picture]
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    async submit () {
      this.submitLoading = true
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        try {
          const { data } = await this.$api.put(this.$resources.ACCOUNT, this.companyPk, this.company)
          this.$toasted.global.success('Société mise à jour')
          this.$store.commit('patchCurrentUser', { account: data.first_admin.account })
          this.submitLoading = false
        } catch (err) {
          this.submitLoading = false
          this.handleError(err)
          console.log(err)
        }
      } else {
        this.submitLoading = false
      }
    },
    deleteCompanyPicture () {
      this.companyPictures = []
      this.company.picture = null
    },
    uploadPictures (files) {
      this.company.picture = files[0]
      this.companyPictures = [files[0]]
    }
  }
}
</script>
